/* eslint-disable prefer-rest-params */
import { combineReducers } from 'redux';
import { SEARCH_LIST_PAGE_SIZE } from '@/constants/searchList';
// 更新数据
const INITIAL_STATE = {
  // params: {
  //   pageNo: 1, // 当前页
  //   pageSize: 60, // 每页的数量
  // },
  page: 1, // 当前页
  pageSize: SEARCH_LIST_PAGE_SIZE,
  toolNum: 0,
  data: [],
  brandList: [],
  priceRangeList: [],
  isShowJDPrice: true,
  userCatList: [],
  extAttrList: [],
  promiseLabels: [],
  searchParam: {},
  loading: true,
  searchSubmitting: false,
  fetchError: null as string | null,
  lastFetchParams: null as Record<string, unknown> | null,
  lastFetchSelectParams: null as Record<string, unknown> | null,
  pageInfo: {},
  view: 1,
  checkedCount: 0,
  allMkuIds: [], //skuId
  canMcSearch: 0,
  expandQuery: {},
  selectParams: {},
  // 搜索内容
  queryValue: '',
};

const updateGoodsData = (state: any, action: any) => {
  const hasDeliveryFilter = Array.isArray(action.params?.promiseLabels) && action.params.promiseLabels.length > 0;
  const responsePromiseLabels = Array.isArray(action.promiseLabels) ? action.promiseLabels : [];
  // 选择时效后接口聚合结果会收窄；筛选面板需保留本次搜索未筛选时的可选项，避免其他开关消失。
  const promiseLabels = hasDeliveryFilter
    ? Array.from(new Set([...(state.promiseLabels || []), ...responsePromiseLabels]))
    : responsePromiseLabels;

  return {
    ...state,
    pageInfo: action.pageInfo,
    data: action.data,
    brandList: action.brandList ?? [],
    isShowJDPrice: action.isShowJDPrice,
    priceRangeList: action.priceRangeList ?? [],
    userCatList: action.userCatList,
    extAttrList: action.extAttrList ?? [],
    promiseLabels,
    searchExtAttrList: action.extAttrList ?? [],
    searchParam: action.searchParam,
    toolNum: action.toolNum,
    params: action.params,
    page: action.page,
    selectParams: action.selectParams,
    pageSize: action.pageSize,
    loading: false,
    searchSubmitting: false,
    fetchError: null,
    allMkuIds: action.allMkuIds,
    canMcSearch: action.canMcSearch,
    expandQuery: action.expandQuery,
  };
};

const updateAllChecked = (state: any, action: any) => {
  const arr = state.data.map((item: any) => {
    return {
      ...item,
      checked: action.isChecked,
    };
  });
  return {
    ...state,
    data: arr,
  };
};
const updateOneChecked = (state: any, action: any) => ({
  ...state,
  // Reducer 只能派生新条目，不能改写旧 state 内的商品对象。
  data: state.data.map((item: any) =>
    item.mwareId == action.id ? { ...item, checked: action.isChecked } : item,
  ),
});
const updateOneNum = (state: any, action: any) => ({
  ...state,
  data: state.data.map((item: any) =>
    item.mwareId == action.id ? { ...item, mkuNum: action.num } : item,
  ),
});
const updateView = (state: any, action: any) => {
  return {
    ...state,
    view: action.viewType,
  };
};
const updateCheckCount = (state: any, action: any) => {
  return {
    ...state,
    checkedCount: action.count,
  };
};
const updateAllCheckCount = (state: any, action: any) => {
  const contrastIds = new Set((action.contrastList || []).map((item: any) => item.skuId));
  return {
    ...state,
    data: state.data.map((item: any) => ({ ...item, compareCheck: contrastIds.has(item.mwareId) })),
  };
};
const updateCheckContrast = (state: any, action: any) => ({
  ...state,
  data: state.data.map((item: any) =>
    item.mwareId == action.id ? { ...item, compareCheck: action.isChecked } : item,
  ),
});
// 更新搜索内容
const updateQueryName = (state: typeof INITIAL_STATE, action: { queryName: string }) => {
  window.localStorage.setItem('iv', action.queryName);
  return {
    ...state,
    queryName: action.queryName,
  };
};
const setSearchListLoading = (state: any, action: any) => ({
  ...state,
  loading: true,
  searchSubmitting: true,
  fetchError: null,
  // 请求发出即写入筛选 params，侧边栏品牌/价格可立即回显，不必等接口返回
  params: action.params ?? state.params,
  selectParams: action.selectParams ?? state.selectParams,
  lastFetchParams: action.params ?? state.lastFetchParams,
  lastFetchSelectParams: action.selectParams ?? state.lastFetchSelectParams,
});

const setSearchListFetchError = (state: any, action: any) => ({
  ...state,
  loading: false,
  searchSubmitting: false,
  fetchError: action.message || '加载失败，请稍后重试',
  lastFetchParams: action.params ?? state.lastFetchParams,
  lastFetchSelectParams: action.selectParams ?? state.lastFetchSelectParams,
});

function getGoodsData(state = INITIAL_STATE, action: any) {
  switch (action.type) {
    case 'SEARCH_LIST_LOADING_START':
      return setSearchListLoading(state, action);
    case 'SEARCH_LIST_FETCH_ERROR':
      return setSearchListFetchError(state, action);
    case 'UPDATE_GOODSLIST':
      return updateGoodsData(state, action);
    case 'UPDATE_ALL':
      return updateAllChecked(state, action);
    case 'UPDATE_ONE':
      return updateOneChecked(state, action);
    case 'UPDATE_NUM':
      return updateOneNum(state, action);
    case 'UPDATE_VIEW':
      return updateView(state, action);
    case 'UPDATE_CHECKCOUNT':
      return updateCheckCount(state, action);
    case 'UPDATE_ALLCHECKCONTRAST':
      return updateAllCheckCount(state, action);
    case 'UPDATE_CHECKCONTRAST':
      return updateCheckContrast(state, action);
    case 'UPDATE_QUERY_NAME': // 搜索内容
      return updateQueryName(state, action);
    default:
      return state;
  }
}
const reducer = combineReducers({
  getGoodsData,
});

export default getGoodsData;
